import axios from '@axios'

export const state = {
  colors: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allColors: (state) => state.colors,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPage: (state) => state.totalPage,
  totalRecord: (state) => state.totalRecord,
}

export const mutations = {
  CLEAR_COLOR_STATE: (state) => {
    state.colors = []
    state.currentPage = 1
    state.perPage = 15
    state.totalPage = 1
    state.totalRecord = 0
  },
  GET_COLORS: (state, resp) => {
    if (!resp) return null
    state.colors = resp.colors
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPage = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  COLOR_COLOR: (state, car) => {
    // car.id = new Date().getTime()
    // state.cars.push(car)
  },
  UPDATE_COLOR: (state, car) => {
    // for (let i = 0; i < state.cars.length; i++) {
    //   if (state.cars[i].id === car.id) {
    //     car.id = new Date().getTime()
    //     for (let field in state.cars[i]) {
    //       state.cars[i][field] = car[field]
    //     }
    //     break
    //   }
    // }
  },
  REMOVE_COLOR: (state, deletedCar) => {
    // state.cars = state.cars.filter((car) => car.id !== deletedCar.id)
  },
}

export const actions = {
  async getColors({ commit }) {
    commit('CLEAR_COLOR_STATE')
    await axios
      .get(`/api/colors`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('CLEAR_COLOR_STATE')
          let data = Object.assign({}, resp.data)
          commit('GET_COLORS', data)
        }
      })
      .catch(() => {
        commit('GET_COLORS', null)
      })
  },
}
